"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormattedMessage;
exports.getMessage = getMessage;
var _intlProvider = require("./intl-provider.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["id", "values", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// RegExp to find replacement values in string, denoted by `{}`.
var brackets = /(\{.*?\})/g;
var inner = /\{(.*)\}/;

/**
 * Detect if the given part is a Rich React element that needs to be rendered as is or should be concatenated as string.
 *
 * @param {any} part Part to check if it is a React element.
 * @returns {boolean} True if part is a React element.
 * @private
 */
function rich(part) {
  var type = Object.prototype.toString.call(part).slice(8, -1).toLowerCase();
  return type === 'object' && part.$$typeof || type === 'array';
}

/**
 * Perform message lookup and replacement of brackets.
 *
 * @param {object} messageDescriptor { id, defaultMessage }. id: Property reference in messages, defaultMessage: fallback message.
 * @param {object} values Replacement values lookup dictionary.
 * @param {object} messages Messages dictionary.
 * @returns {String|Array} Array of React-renderable parts.
 * @private
 */
function getMessage(_ref, values) {
  var _messages$id;
  var id = _ref.id,
    defaultMessage = _ref.defaultMessage;
  var messages = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var message = (_messages$id = messages[id]) !== null && _messages$id !== void 0 ? _messages$id : defaultMessage;
  if (!message) return id;
  if (!values) return message;

  //
  // We're not using React.Children to create the array, we're abusing it to
  // introduce missing `key` properties to the Rich Text elements that might be
  // included in the message value's. This way we mimic the React Intl automatic
  // key generation for the elements.
  //
  return _react["default"].Children.toArray(message.toString().split(brackets).map(function (part) {
    var match = part.match(inner);
    if (!match) return part;
    if (match[1] in values) return values[match[1]];
    return part;
  }).reduce(function (all, part) {
    if (!all.length || rich(part) || rich(all[all.length - 1])) {
      all.push(part);
    } else {
      all[all.length - 1] += part;
    }
    return all;
  }, [])).filter(Boolean);
}

/**
 * Return locale specific human readable string based on message lookup from context.
 * Allow a single child to be passed as function, which will receive the lookup string
 * as first argument. If the first child is a function, return the plain message without
 * any replacement values. The function internals will have to implement logic if required.
 *
 * @param {string} id Property reference in messages.
 * @param {object} values Replacement values lookup dictionary.
 * @param {Array<ReactElement>} children React renderable nodes.
 * @returns {ReactElement} Span or children of component.
 * @public
 */
function FormattedMessage(_ref2) {
  var id = _ref2.id,
    values = _ref2.values,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useContext = (0, _react.useContext)(_intlProvider.PolyfillReactIntl),
    messages = _useContext.messages;
  if (children && typeof children === 'function') {
    return children(getMessage({
      id: id
    }, values, messages));
  }
  return /*#__PURE__*/_react["default"].createElement("span", props, getMessage({
    id: id
  }, values, messages));
}
FormattedMessage.propTypes = {
  id: _propTypes["default"].string.isRequired,
  values: _propTypes["default"].object,
  children: _propTypes["default"].func,
  props: _propTypes["default"].object
};